import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import API from "../Service/Baseservice";
import "../FAQ/FAQ.css";
import Faqpreview from "../FAQ/FAQPreview";
import CharIcon from "../../Assets/img/word.png";

const FAQEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const faq = location.state?.faq;
    const page = location.state?.page || 1;
    const [formData, setFormData] = useState({
        language_id: faq?.language_id || 1,
        faqs_id: faq?.faqs_id || "",
        question: faq?.question || "",
        answers: faq?.answers || "",
        category_id: faq?.category_id?.toString() || "",
        status: faq?.status || "active",
        active: faq?.active?.toString() || "1",
    });

    const [categories, setCategories] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const MAX_CHARS = 4000;
    const [lastValidAnswer, setLastValidAnswer] = useState(
        faq?.answers || ""
    );

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    };

    useEffect(() => {
        API.post("faqsCategory_list/condition", {
            language_id: formData.language_id,
        })
            .then((res) => {
                const categoryData = res?.data?.data?.data || [];
                const activeCategories = categoryData.filter(
                    (item) => item.active === 1 || item.active === "1"
                );
                setCategories(activeCategories);
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to load categories.",
                    type: "failed",
                })
            );
    }, [formData.language_id]);


    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = () => {
        if (!formData.category_id || !formData.question || !formData.answers) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields.",
                type: "info",
            });
            return;
        }

        const payload = {
            language_id: Number(formData.language_id),
            faqs_id: Number(id),
            question: formData.question,
            answers: formData.answers,
            status: formData.status,
            active: Number(formData.active),
            category_id: Number(formData.category_id),
        };

        setIsSubmitting(true);
        API.post("faqs_edit/update", payload)
            .then((res) => {
                if (res.data?.success) {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: res.data?.message || "FAQ updated successfully!",
                        type: "success",
                    });
                    // setTimeout(() => navigate("/faq", { state: { page } }), 3500);
                } else {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: res.data?.message || "Failed to update FAQ!",
                        type: "error",
                    });
                }
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to update FAQ.",
                    type: "error",
                })
            )
            .finally(() => setIsSubmitting(false));
    };

    const handlePreview = () => {
        if (!formData.category_id || !formData.question || !formData.answers) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all fields before previewing.",
                type: "info",
            });
            return;
        }
        setPreviewData({ ...formData });
        setShowPreview(true);
    };

    return (
        <div className="news-container">
            <div className="newsadd-container">
                {/* Header */}
                <div className="newsadd-header">
                    <h2 className="newsadd-title">Edit FAQ</h2>
                    <div className="header-buttons">
                        <button onClick={handlePreview} className="btn saves-btn">
                            Preview
                        </button>
                        <button
                            onClick={handleSubmit}
                            className="btn saves-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Update" : "Update"}
                        </button>
                        <button onClick={() => navigate("/faq", { state: { page } })} className="cancel-btn ">
                            Back
                        </button>
                    </div>
                </div>

                {/* Form */}
                <div className="newsadd-formcard">
                    <div className="form-group">
                        <label>
                            Category <span className="required">*</span>
                        </label>
                        <select
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Category</option>
                            {categories.map((cat) => (
                                <option key={cat.category_id} value={cat.category_id}>
                                    {cat.category}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Question <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {formData.question.length}/100
                                </span>
                            </div>
                        </label>
                        <input
                            type="text"
                            name="question"
                            placeholder="Enter question"
                            value={formData.question}
                            onChange={(e) => {
                                if (e.target.value.length <= 100) {
                                    setFormData({ ...formData, question: e.target.value });
                                }
                            }}
                        />
                    </div>

                    {/* ANSWER FIELD */}
                    <div className="form-group">
                        <label className="description-label">
                            <span className="label-text">
                                Answer <span className="required">*</span>
                            </span>
                            <div className="char-wrapper">
                                <img src={CharIcon} alt="Character count" />
                                <span className="char-count">
                                    {getPlainTextLength(formData.answers)}/4000
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.answers}

                            onChange={(event, editor) => {
                                const html = editor.getData();

                                const div = document.createElement("div");
                                div.innerHTML = html;
                                const textLength = div.textContent?.length || 0;

                                if (textLength <= MAX_CHARS) {
                                    setLastValidAnswer(html);
                                    setFormData(prev => ({
                                        ...prev,
                                        answers: html
                                    }));
                                } else {
                                    editor.setData(lastValidAnswer);
                                }
                            }}

                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                            className="description1-editor"
                        />

                    </div>
                </div>
            </div>

            {/*  Preview Modal */}
            {showPreview && (
                <div className="preview-overlay" onClick={() => setShowPreview(false)}>
                    <div
                        className="preview-modal-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="close-btn" onClick={() => setShowPreview(false)}>
                            ✕
                        </button>
                        <Faqpreview previewNews={previewData} />
                    </div>
                </div>
            )}

            {/*  Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/faq");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FAQEdit;
